import * as z from "zod";

export const getRegistrationCustomerTags = {
  name: "getRegistrationCustomerTags" as const,
  input: z.object({}),
  output: z.object({ tags: z.array(z.string()) }),
};
